'use client';

import { SnackbarProvider } from 'notistack';
import MessageSnackbar from 'shared/snackbars/messege-snackbar';
import type { ReactNode } from 'react';
export const NotistackSnackbarProvider = ({
  children
}: {
  children: ReactNode;
}) => <SnackbarProvider maxSnack={3} Components={{
  customMessage: MessageSnackbar
}} data-sentry-element="SnackbarProvider" data-sentry-component="NotistackSnackbarProvider" data-sentry-source-file="notistack-snackbar-provider.tsx">
    {children}
  </SnackbarProvider>;